import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useFormikContext } from 'formik';

import Car from 'common/components/auto/cars/car';
import { ChoiceList } from '../make-a-change-drawer/change-picker';

const noop = () => {};

// The condensed Make a change drawer's auto "Deductible": deductibles are per car, so pick the car, then edit its
// card. The card is the same one the Cars list shows, opened, without its remove button.
const CarDeductiblePicker = ({ disabled }) => {
  const { values } = useFormikContext();
  const cars = values.cars ?? [];
  const [carIndex, setCarIndex] = useState(cars.length === 1 ? '0' : null);
  const car = carIndex === null ? null : cars[Number(carIndex)];

  return (
    <>
      {cars.length > 1 && (
        <ChoiceList
          legend="Which car?"
          name="make-a-change-car"
          options={cars.map(({ year, make, model }, index) => ({
            value: String(index),
            label: [year, make, model].filter(Boolean).join(' ') || `Car ${index + 1}`
          }))}
          value={carIndex}
          onChange={setCarIndex}
        />
      )}
      {car && (
        <Car
          key={carIndex}
          fieldName={`cars[${carIndex}]`}
          index={Number(carIndex)}
          item={{ ...car, initialOpen: true }}
          disabled={disabled}
          fromPolicy
          hideRemove
          onRemove={noop}
          removeFromList={noop}
        />
      )}
    </>
  );
};

CarDeductiblePicker.propTypes = {
  disabled: PropTypes.bool
};

CarDeductiblePicker.defaultProps = {
  disabled: false
};

export default CarDeductiblePicker;
